import React from 'react';
import { Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useModal } from 'components/modal/hooks/useModal';
import { useOrderResumeProducts } from '../../../hooks/useOrderResumeProducts';
import { OrderProduct } from 'types/order';

const useStyles = makeStyles(theme => ({
  finalPrice: {
    color: ({ isSelected }: { isSelected: boolean }) => (isSelected ? theme.palette.primary.contrastText : '#888'),
    textAlign: 'right',
    minWidth: 80,
    fontWeight: 500,
  },
}));

type OrderResumeUpdateButtonProps = {
  product: OrderProduct | null;
  total: string;
  amount: number;
};

const OrderResumeUpdateButton: React.FC<OrderResumeUpdateButtonProps> = ({ product, total, amount }) => {
  const classes = useStyles({ isSelected: !!product?.ready });
  const { handleModalClose } = useModal();
  const { handleUpdateProduct } = useOrderResumeProducts();

  function handleConfirm() {
    if (!product?.ready) {
      return;
    }

    handleUpdateProduct(product, amount);
    handleModalClose();
  }

  return (
    <Button disabled={!product?.ready} variant="contained" size="large" color="primary" onClick={handleConfirm}>
      <span>Atualizar</span>

      <Typography className={classes.finalPrice} color="textPrimary">
        {total}
      </Typography>
    </Button>
  );
};

export default OrderResumeUpdateButton;
